import * as React from "react";
import { Tooltip, Typography } from "@bolteu/kalep-react";
import InfoCircleOutlined from "@bolteu/kalep-react-icons/dist/InfoCircleOutlined";
import { cx } from "../../utils/cx";
export function AccordionTableColumnHeader({ children, tooltip, tooltipProps }) {
    const [isOpen, setIsOpen] = React.useState(false);
    const timerRef = React.useRef(undefined);
    const onClick = React.useCallback((event) => {
        event.stopPropagation();
        setIsOpen((flag) => !flag);
        if (timerRef) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            setIsOpen(false);
        }, 2000);
    }, [setIsOpen]);
    React.useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);
    const headerContent = (React.createElement(Typography, { variant: "caption-primary", color: "secondary", inline: true }, children));
    if (!tooltip) {
        return headerContent;
    }
    return (React.createElement("div", { className: cx("flex flex-wrap gap-1") },
        headerContent,
        React.createElement(Tooltip, Object.assign({ placement: "top", content: tooltip, isOpen: isOpen, onOpenChange: setIsOpen }, tooltipProps),
            React.createElement("span", { className: cx("flex items-center") },
                React.createElement(InfoCircleOutlined, { size: "xs", className: cx("text-secondary"), onClick: onClick })))));
}
